import {
  ApiException,
  DocumentInputModel,
  DocumentViewModel,
  FileParameter,
  WorkflowInputModel,
  WorkflowResultViewModel,
  WorkflowsApi,
  WorkflowSearchInputModel,
  WorkflowSearchResultsViewModel,
} from '@ail/workflows-api'
import { createApi } from '@reduxjs/toolkit/query/react'
import { USER_MANAGER } from '../../auth/UserManager'
import { Environment } from '../../environment'
import { getBaseQuery } from './apiQuery'

const client = new WorkflowsApi({
  baseUrl: Environment.WorkflowsApiUrl,
  getToken: async () => {
    const user = await USER_MANAGER.getUser()
    return user?.access_token ?? ''
  },
})

// prettier-ignore
export const workflowsApi = createApi({
  reducerPath: 'workflowsApi',
  baseQuery: getBaseQuery<ApiException>(),
  endpoints: (builder) => ({
    searchWorkflows: builder.query<WorkflowSearchResultsViewModel, { searchTerm?: string, page?: number, count?: number, model?: WorkflowSearchInputModel }>({
      query: (rq) => client.searchWorkflows(rq.searchTerm, rq.page, rq.count, rq.model),
      providesTags: ['Workflows']
    }),
    getWorkflow: builder.query<WorkflowResultViewModel, string>({
      query: (workflowId) => client.getWorkflow(workflowId),
      providesTags: ['Workflows']
    }),
    startWorkflow: builder.mutation<string | undefined, { reference?: string | null; model: WorkflowInputModel }>({
      query: ({ reference, model }) =>
        client.startWorkflow(reference, model).then((r) => ({ data: r.meta.headers.location })),
    }),
    createDocument: builder.mutation<DocumentViewModel, DocumentInputModel>({
      query: (model) => client.createDocument(model),
    }),
    uploadDocument: builder.mutation<void, { documentId: string; file?: FileParameter | null }>({
      query: ({ documentId, file }) => client.uploadDocument(documentId, file),
    }),
  }),
  tagTypes: ['Workflows']
})

export const {
  useStartWorkflowMutation,
  useLazyGetWorkflowQuery,
  useGetWorkflowQuery,
  useCreateDocumentMutation,
  useUploadDocumentMutation,
  useSearchWorkflowsQuery,
} = workflowsApi
